import { NavLink } from "react-router-dom";
import { useAppDispatch } from "../../../../redux/hooks";
import { deleteCatalog, deleteCatalogType } from "../../../../redux/reducers";
import { ICatalogType } from "../../../../types";
import styles from "./index.module.scss";
import api from "../../../../api";

interface ICatalogProps extends ICatalogType {
  index: number;
}
const Catalog = ({ catalogTypeId, catalogName, index }: ICatalogProps) => {
  const dispatch = useAppDispatch();
  return (
    <tr className={styles.root}>
      <th>{index + ". " + catalogName}</th>
      <th className={styles.actions}>
        <button
          onClick={() => {
            dispatch(deleteCatalogType(catalogName));
          }}
        >
          Удалить
        </button>
        <NavLink to={"/admin/catalogs/" + catalogName}>Добавить Деталь</NavLink>
        <NavLink to={"/admin/catalog/" + catalogName}>Посмотреть</NavLink>
      </th>
    </tr>
  );
};

export default Catalog;
